import React from "react";

import {
  Box,
  Stepper,
  styled,
  Step,
  StepLabel,
  Typography,
  StepConnector,
} from "@mui/material";

// Custom connector with solid line for main steps and dashed line for substeps
const CustomConnector = styled(StepConnector)(({ theme }) => ({
  "& .MuiStepConnector-line": {
    borderLeftWidth: 2,
    borderRadius: 1,
    borderLeft: "1.5px dashed #4BC7E1",
    marginTop: 0,
  },
  // Apply styles conditionally for the first step to remove the top part of the line
  "&:first-of-type .MuiStepConnector-line": {
    display: "none",
  },
}));

const CreatePostStepper = ({ steps, activeStep, activeSubStep }) => {
  return (
    <Box sx={{ width: "100%", maxWidth: 300, p: "0.7rem" }}>
      <Stepper
        orientation="vertical"
        connector={<CustomConnector />}
        sx={{
          "& .MuiStep-root": {
            "& .MuiStepLabel-label": {
              fontSize: 16,
            },
            "& .Mui-disabled .MuiStepLabel-label": {
              color: "grey.400",
            },
          },
        }}
      >
        {steps?.map((step, index) => (
          <React.Fragment key={step.label}>
            {/* Main Step */}
            <Step
              active={index === activeStep}
              completed={index < activeStep}
              sx={{
                p: "0.8rem",
                border: "1px solid #E0E0E0",
                borderRadius: "12px",
                backgroundColor: index < activeStep ? "#9048FB" : "transparent",
              }}
            >
              <StepLabel
                StepIconComponent={() => (
                  <Box
                    sx={{
                      color: index < activeStep ? "#FFFFFF" : "#9048FB",
                      backgroundColor:
                        index < activeStep ? "#9048FB" : "transparent",
                    }}
                  >
                    {step.icon}
                  </Box>
                )}
              >
                <Typography
                  color={index < activeStep ? "#FFFFFF" : "#9048FB"}
                  fontWeight={index === activeStep ? "bold" : "normal"}
                  fontSize={{ xs: ".5rem", md: ".8rem" }}
                >
                  {step.label}
                </Typography>
              </StepLabel>
            </Step>

            {/* Render Substeps only if the current step is active */}
            {index === activeStep &&
              step.subSteps?.map((subStep, subIndex) => (
                <Box
                  key={subStep.label}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    ml: 1.5,
                    pt: 2, // Indentation for substeps
                    borderLeft: "1px dashed #4BC7E1",
                  }}
                >
                  <Box
                    sx={{
                      width: "11px",
                      border: `2px solid ${
                        activeSubStep >= subIndex ? "#4BC7E1" : "#BFBFBF"
                      }`,
                      borderRadius: "50%",
                      bgcolor: "white",
                      ml: -0.7,
                      height: "11px",
                    }}
                  />
                  <Typography
                    color={activeSubStep >= subIndex ? "#4BC7E1" : "#BFBFBF"}
                    fontSize="0.8rem"
                    fontWeight={activeSubStep >= subIndex ? "bold" : "normal"}
                    ml={2}
                  >
                    {subStep.label}
                  </Typography>
                  {subStep?.optional && (
                    <Box
                      bgcolor="#B688FA"
                      borderRadius="30px"
                      px={1}
                      ml={"0.3rem"}
                      mr={-1}
                    >
                      <Typography
                        fontSize="0.7rem"
                        fontWeight={500}
                        color="white"
                      >
                        Optional
                      </Typography>
                    </Box>
                  )}
                </Box>
              ))}
          </React.Fragment>
        ))}
      </Stepper>
    </Box>
  );
};

export default CreatePostStepper;
